export default __webpack_public_path__ + "static/media/cube.a15a9ed9.gif";